import type { ProtheusClient } from './types';

export type ProtheusPartyReference = Pick<ProtheusClient, 'code' | 'store'>;

export function buildProtheusPartyKey({ code, store }: ProtheusPartyReference): string {
  return `${encodeURIComponent(code)}|${encodeURIComponent(store)}`;
}

export function isSameProtheusParty(
  first: ProtheusPartyReference,
  second: ProtheusPartyReference
): boolean {
  return first.code === second.code && first.store === second.store;
}
